import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import { Link } from 'react-router-dom';
import { StatusPill, ActionIconButton, ListPageShell, EmptyState } from '../../Components/Ui'

const CustomersList = () => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [stateFilter, setStateFilter] = useState('')
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.customers.get_customers().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const filteredRows = useMemo(() => {
        return (rows || []).filter(r => {
            if (stateFilter === '1' && parseInt(r.state_cust) !== 1) return false
            if (stateFilter === '0' && parseInt(r.state_cust) === 1) return false
            return true
        })
    }, [rows, stateFilter])

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_nomina', text: 'ID', align: 'center' },
                {
                    name: 'full_name_cust', text: 'Colaborador', render: r => (
                        <div className="sp-cell-main">
                            <strong>{r.full_name_cust}</strong>
                            <span className="sp-cell-meta">{r.email_cust}</span>
                        </div>
                    )
                },
                { name: 'state_civil_cust', text: 'Estado Civil' },
                { name: 'state_cust', text: 'Estado', align: 'center', render: r => <StatusPill tone={parseInt(r.state_cust) === 1 ? 'success' : 'danger'}>
                    {parseInt(r.state_cust) === 1 ? 'Activo' : 'Inactivo'}
                </StatusPill> },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    return ''
                    if (parseInt(u.id_customers) === 1 && Helpers.config.isDeveloperWeb()) {
                        return ''
                    }
                    return <div className="sp-row-actions">
                        <Link to={Helpers.config.convertUrl({ url: '/colaboradores/' + u.id_customers })}>
                            <ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" />
                        </Link>
                    </div>
                } },
            ],
        ]}
        rows={filteredRows}
        isProcessing={isProcessing}
    />, [filteredRows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && filteredRows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Colaboradores CRM"
            subtitle="Consulta y administra el directorio de colaboradores desde un solo lugar."
            badge="Actividad actualizada"
            primaryAction={
                <Link to={Helpers.config.convertUrl({ url: '/registro-colaborador' })} style={{ textDecoration: 'none' }}>
                    <ListPageShell.PrimaryButton icon="fa fa-plus">
                        Registrar Colaborador
                    </ListPageShell.PrimaryButton>
                </Link>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Estado',
                    control: (
                        <select value={stateFilter} onChange={e => setStateFilter(e.target.value)}>
                            <option value="">Todos</option>
                            <option value="1">Activo</option>
                            <option value="0">Inactivo</option>
                        </select>
                    )
                },
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Nombre o email…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-users"
                    title="No hay colaboradores"
                    text="Registra un colaborador para comenzar."
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>
    </>
}

export default CustomersList
